export default "__VITE_ASSET__03e3b2bc__"